import { P } from '@angular/cdk/keycodes';
import { configuration } from './configuration';

/**
 * return the full site url
 */
export const SITE_URL = `https://${configuration.site}.${configuration.domain}`;

/**
 * return the base backend/API server end point url
 */
export const API_BASE_URL = `https://${configuration.api}.${configuration.domain}/v1/index.cfm`;

export const CAREER_PREVIEW_URL = `https://${configuration.api}.${configuration.domain}/career/index.cfm`;

export const SLACK_API = 'https://slack.com/api';

/**
 *  API end point URLs
 */
export class ApiEndPoint {
  /**
   * Auth
   */
  public static authorize = API_BASE_URL + '/authorize';
  public static socialLogin = API_BASE_URL + '/googlelogin';

  /**
   * Company Initial Setup Procedure/Introduction
   */
  public static introduction = API_BASE_URL + '/setup_procedure';

  public static Common = {
    countries: API_BASE_URL + '/countries',
    states: API_BASE_URL + '/get_states',
    resources: API_BASE_URL + '/get_resourcePosting',
  };

  public static Search = {
    jobs: API_BASE_URL + '/searchJobs',
    candidates: API_BASE_URL + '/searchCandidates',
    history: API_BASE_URL + '/gethistory',

    Instant: {
      jobs: API_BASE_URL + '/quick_search/job',
      candidates: API_BASE_URL + '/quick_search/candidate',
    },
  };

  public static Home = {
    statistics: API_BASE_URL + '/stat4landing',
    activities: API_BASE_URL + '/chart_activity',
    flows: API_BASE_URL + '/chart_flow',
    schedule: API_BASE_URL + '/allschedule',
    notifications: API_BASE_URL + '/allnotification',
  };

  /**
   *  Jobs
   */
  public static Jobs = {
    // Dashboard
    Dashboard: {
      statistics: API_BASE_URL + '/stat_5_jobs',
      notifications: API_BASE_URL + '/joblandingnotification',
      alerts: API_BASE_URL + '/joblandingalert',
      // Jobs count posted on the other sites such as Linkedin, ZipRecruiter, Indeed, Glassdoor, etc
      sites: API_BASE_URL + '/mainjobboardcount',
      chart: API_BASE_URL + '/job_chart_all',
      availables: API_BASE_URL + '/jobslanding',
    },

    // Listing
    all: API_BASE_URL + '/jobs',
    owners: API_BASE_URL + '/poweruserjobs',

    // Detail
    details: API_BASE_URL + '/jobdetail',
    notifications: API_BASE_URL + '/job_notification',
    chart: API_BASE_URL + '/job_chart',
    aiBots: API_BASE_URL + '/job_aicount',
    flowStatistics: API_BASE_URL + '/job_wfcount',

    inline: API_BASE_URL + '/jobs/inline',

    save: API_BASE_URL + '/job_save',

    action: API_BASE_URL + '/job_action',
    share: API_BASE_URL + '/job_share',

    delete: API_BASE_URL + '/job_delete',

    Keywords: {
      all: API_BASE_URL + '/getkeyword',
      update: API_BASE_URL + '/put_jobkeyword',
    },

    location: API_BASE_URL + '/getjoblocation',

    expirationDates: API_BASE_URL + '/getdbreference/jobPostingExpirationDate',

    salary: API_BASE_URL + '/getjobsalary',
    salaryRange: API_BASE_URL + '/getsalaryrange',
    currencies: API_BASE_URL + '/get_jobcurrency',

    categories: API_BASE_URL + '/getjobcategory',
    subcategories: API_BASE_URL + '/getjobsubcategory',
    eeoCategories: API_BASE_URL + '/geteeojobcategory',

    types: API_BASE_URL + '/getjobtype',
    shifts: API_BASE_URL + '/getshift',
    confidentials: API_BASE_URL + '/getdbreference/jobPostingConfidential',
    languages: API_BASE_URL + '/getlanguage',
    levels: API_BASE_URL + '/getjoblevel',
    experienceYears: API_BASE_URL + '/getyearsexp',
    educationLevels: API_BASE_URL + '/geteducationlevel',
    durations: API_BASE_URL + '/getdbreference/jobPostingDuration',
    travelFrequencies: API_BASE_URL + '/getdbreference/jobPostingTravelFrequency',

    // Step 5
    customFields: API_BASE_URL + '/getcustomfield_job',

    powerUsers: API_BASE_URL + '/getpoweruser',

    HiringManagers: {
      all: API_BASE_URL + '/gethiringmanager',
      allInJob: API_BASE_URL + '/gethiringmanagerbyjob',
      update: API_BASE_URL + '/put_hiringmanager',
    },

    Recruiters: {
      all: API_BASE_URL + '/getrecruiter',
      update: API_BASE_URL + '/put_recruiter',
    },

    questions: API_BASE_URL + '/job_questions',

    scorecard: API_BASE_URL + '/getscorecard',

    Resources: {
      all: API_BASE_URL + '/getresource',
      update: API_BASE_URL + '/jobboards',
    },

    businessUnits: API_BASE_URL + '/bujobs',
    departments: API_BASE_URL + '/deptjobs',

    board: API_BASE_URL + '/job_jbcount',

    workflows: API_BASE_URL + '/job_recruitflow',
    history: API_BASE_URL + '/job_detailhistory',

    preText: API_BASE_URL + '/getpretext',

    insert: API_BASE_URL + '/insertjob',
    update: API_BASE_URL + '/update_job',
  };

  public static JobApprovals = {
    approvals: API_BASE_URL + '/jobapprovals',
    history: API_BASE_URL + '/jobapprovals/history',
    delete: API_BASE_URL + '/jobapprovals/delete',
    resent: API_BASE_URL + '/jobapprovals/resend',
  };

  public static Candidates = {
    all: API_BASE_URL + '/candidatelandingcounts/0',
    // unused
    powerUsers: API_BASE_URL + '/powerusercandidates',

    FilterBy: {
      activityDays: API_BASE_URL + '/daysFilter',
    },

    details: API_BASE_URL + '/candidate_detail',
    basic: API_BASE_URL + '/candidates',
    profile: API_BASE_URL + '/candidates/profile',

    upload: API_BASE_URL + '/upload_fileresume',
    add: API_BASE_URL + '/insert_resume',
    update: API_BASE_URL + '/update_resume2',
    insert: API_BASE_URL + '/insert_candidate',

    bestMatches: API_BASE_URL + '/job_bestmatch',
    history: API_BASE_URL + '/job_history',

    thirdParties: API_BASE_URL + '/thirdparty',

    SkillTags: {
      all: API_BASE_URL + '/get_skilltag',
      labels: API_BASE_URL + '/get_skilllabel',
      add: API_BASE_URL + '/add_skilltag',
      update: API_BASE_URL + '/put_skilltag',
      delete: API_BASE_URL + '/delete_skilltag',
    },

    Tasks: {
      all: API_BASE_URL + '/get_task',
      send: API_BASE_URL + '/send_task',
      tasks: API_BASE_URL + '/tasks', // no used?
      update: API_BASE_URL + '/update_task',
    },

    Schedule: {
      history: API_BASE_URL + '/previous_schedule',
      all: API_BASE_URL + '/get_schedule',
      add: API_BASE_URL + '/schedule',
      invite: API_BASE_URL + '/send_invite',
    },

    Comments: {
      all: API_BASE_URL + '/comment',
      history: API_BASE_URL + '/get_comment',
      send: API_BASE_URL + '/add_comment',
    },

    Texts: {
      all: API_BASE_URL + '/candidatesmslog',
      text: API_BASE_URL + '/get_text',
      send: API_BASE_URL + '/send_text',
      buzzWords: API_BASE_URL + '/candidate_text/buzz',
      hashTags: API_BASE_URL + '/candidate_text/hashtag',
    },

    Emails: {
      all: API_BASE_URL + '/getemail',
      send: API_BASE_URL + '/sendemail',
    },

    Shares: {
      all: API_BASE_URL + '/candidateshare',
      history: API_BASE_URL + '/getshare',
      send: API_BASE_URL + '/sendshare',
    },

    questions: API_BASE_URL + '/candidatequestions',

    colors: API_BASE_URL + '/color',

    appliedJobs: API_BASE_URL + '/jobapplied',

    ethnicity: API_BASE_URL + '/ethnicity',

    gender: API_BASE_URL + '/gender',

    EEO: {
      details: API_BASE_URL + '/EEO',

      source: API_BASE_URL + '/eeosource',

      veteran: API_BASE_URL + '/eeovet',

      Disposition: {
        all: API_BASE_URL + '/eeodisposition',
        dispositions: API_BASE_URL + '/get_eeojobdisposition',
      },

      update: API_BASE_URL + '/update_eeo',
    },

    doNotHire: API_BASE_URL + '/donothire',
    duplicated: API_BASE_URL + '/duplicateprofile',

    hireInfo: API_BASE_URL + '/hire_info',
    customFields: API_BASE_URL + '/candcustomfields',

    Resume: {
      text: API_BASE_URL + '/getresume',

      file: API_BASE_URL + '/file_resume',
      update: API_BASE_URL + '/update_fileresume',
    },

    Uploaded: {
      all: API_BASE_URL + '/uploaded_file',
      add: API_BASE_URL + '/candidate_upload',
    },

    application: API_BASE_URL + '/getapplication',
    background: API_BASE_URL + '/getbackground',

    Reference: {
      all: API_BASE_URL + '/getreference',
      check: API_BASE_URL + '/candidatereferencecheck',
      resend: API_BASE_URL + '/resendPendingReferences',
    },

    scorecard: API_BASE_URL + '/update_candidatescorecard',

    sources: API_BASE_URL + '/sources',

    valid: API_BASE_URL + '/candidates/validate',

    assign: API_BASE_URL + '/assignjobs',
    unassign: API_BASE_URL + '/unassignjob',
    move: API_BASE_URL + '/move_recruitflow',

    // used - ?
    timeline: API_BASE_URL + '/timeline',

    Communication: {
      get: API_BASE_URL + '/communication',
    },
  };

  /**
   *  Candidate Onboarding
   */
  public static Onboarding = {
    all: API_BASE_URL + '/candidatelandingcounts',
    employees: API_BASE_URL + '/onboarding_employee',

    tasks: API_BASE_URL + '/onboarding_task',
    documents: API_BASE_URL + '/onboarding_document',
    teamNotifications: API_BASE_URL + '/onboarding_teamnotification',
    emergencyContacts: API_BASE_URL + '/onboarding_emergencycontact',

    sendEmail: API_BASE_URL + '/onboarding_sendemailtocand',
    sendToEmployee: API_BASE_URL + 'onboarding_sendtoemployee',
  };

  /**
   * Advanced Search
   */
  public static advancedSearch = API_BASE_URL + '/advanced_search';

  /**
   * Schedule
   */
  public static Schedule = {
    range: API_BASE_URL + '/schedulerange',

    availabilities: API_BASE_URL + '/myschedule',
    availability: API_BASE_URL + '/availability',
    mySchedule: API_BASE_URL + '/schedule',
    confirm: API_BASE_URL + '/confirm_schedule',

    Outlook: {
      info: API_BASE_URL + '/googleoutlook/calenderinfo',
      callback: API_BASE_URL + '/googleoutlook/authorize',
    },

    Google: {
      info: API_BASE_URL + '/googleoutlook/googleinfo',
      callback: API_BASE_URL + '/googleoutlook/googlelogin',
    },

    activeCalendar: API_BASE_URL + '/googleoutlook/active_calendar',
    syncCalendar: API_BASE_URL + '/googleoutlook/sync_calendar',

    invite: API_BASE_URL + '/schedule/invite',
    acceptInvite: API_BASE_URL + '/schedule/accept_invite',
  };

  /**
   * Settings
   */
  public static Company = {
    details: API_BASE_URL + '/company/info',
    social: API_BASE_URL + '/company/social',
    duplicated: API_BASE_URL + '/company/duplicated',
    notification: API_BASE_URL + '/notification/company',
    career: API_BASE_URL + '/career/company', // to set the company career page url
    register: API_BASE_URL + '/company/register',

    featurevideo: API_BASE_URL + '/company/featurevideo',
    smsEnabled: API_BASE_URL + '/company/smsenabled',

    partner: API_BASE_URL + '/company/partner',
  };

  /**
   *  Users
   */
  public static Users = {
    details: API_BASE_URL + '/userdetail',
    avatar: API_BASE_URL + '/candidateprofile',
    notification: API_BASE_URL + '/notification/user',
    preference: API_BASE_URL + '/userpreference',

    logins: API_BASE_URL + '/users',
    duplicated: API_BASE_URL + '/users/duplicated',
    password: API_BASE_URL + '/reset_password',

    recruitTeams: API_BASE_URL + '/recruitteams',
    recruitTeam: API_BASE_URL + '/recruitteam',
    singupForms:API_BASE_URL + '/signup_forms',
  };

  public static Auth = {
    requestCode: API_BASE_URL + '/auth/requestCode',
    verifyCode: API_BASE_URL + '/auth/verifyCode',
    setPassword: API_BASE_URL + '/auth/setPassword',

    /**
     * Forgot Password
     */
    requestReset: API_BASE_URL + '/auth/request_reset_password',
    validateReset: API_BASE_URL + '/auth/verify_password_reset',
  };

  /**
   * Workflow
   */
  public static workflows = API_BASE_URL + '/recruitflow';
  public static updateWorkflow = API_BASE_URL + '/update_recruitflow';

  /**
   *  Letters in the Settings/Recruting Preference
   */
  public static letters = API_BASE_URL + '/letters';

  public static CustomFields = {
    Jobs: {
      fields: API_BASE_URL + '/customfields',
      updateOrder: API_BASE_URL + '/update_customfield',
      delete: API_BASE_URL + '/customfields/delete',
    },

    Hire: {
      fields: API_BASE_URL + '/candcustomfields',
      updateOrder: API_BASE_URL + '/update_candcustomfield',
      delete: API_BASE_URL + '/update_candcustomfield/delete',
    },
  };

  /**
   * Job Template
   */
  public static JobTemplates = {
    templates: API_BASE_URL + '/jobtemplate',
    update: API_BASE_URL + '/put_jobtemplate',
    delete: API_BASE_URL + '/put_jobtemplate/delete',
  };

  /**
   *  PreQuestions
   */
  public static PreQuestions = {
    all: API_BASE_URL + '/getprequestions',
    add: API_BASE_URL + '/prequestions',
    update: API_BASE_URL + '/put_prequestions',
    delete: API_BASE_URL + '/put_prequestions/delete',
    groups: API_BASE_URL + '/getprequestiongroup',
  };

  /**
   * Scorecards
   */
  public static Scorecards = {
    all: API_BASE_URL + '/get_scorecard',
    add: API_BASE_URL + '/add_scorecard',
    update: API_BASE_URL + '/update_scorecard',
    delete: API_BASE_URL + '/update_scorecard/delete',
  };

  /**
   *  Business Units and Departments
   */
  public static BusinessUnits = {
    industries: API_BASE_URL + '/industry',
    businessUnits: API_BASE_URL + '/businessunits',

    departments: API_BASE_URL + '/departments',
  };

  public static CompanyOnboard = {
    state: API_BASE_URL + '/onboarding/state',
  };

  /**
   * Onboarding in the settings
   */
  public static OnboardingSettings = {
    // onboarding: API_BASE_URL + '/onboarding',
    tasks: API_BASE_URL + '/onboarding/tasks',

    Documents: {
      all: API_BASE_URL + '/onboarding/documents',
      text: API_BASE_URL + '/onboarding/documents/text',
      file: API_BASE_URL + '/onboarding/documents/file',
      internals: API_BASE_URL + '/onboarding/documents/groups/internal',
      externals: API_BASE_URL + '/onboarding/documents/groups/external',
    },

    teamNotifications: API_BASE_URL + '/onboarding/teamnotifications',

    Links: {
      all: API_BASE_URL + '/onboarding/links',
      groups: API_BASE_URL + '/onboarding/links/group',
    },

    general: API_BASE_URL + '/onboarding/settings',
  };

  public static Career = {
    templates: API_BASE_URL + '/get_careertemplate',
    update: API_BASE_URL + '/update_careertemplate',
    page: API_BASE_URL + '/career',
  };

  /**
   *  Reports
   */
  public static Reports = {
    byoCandidate: API_BASE_URL + '/byo_candidates',
    byoJobs: API_BASE_URL + '/byo_jobs',
    eeo: API_BASE_URL + '/report_eeo',
    savedList: API_BASE_URL + '/report_savedlist',
    save: API_BASE_URL + '/report_save',
  };

  /**
   *  Slack
   */
  public static Slack = {
    channels: SLACK_API + '/conversations.list',
    users: API_BASE_URL + '/slackuserlist',
    profile: API_BASE_URL + '/slackprofile',
    messages: API_BASE_URL + '/getallmsguserslack',
    send: API_BASE_URL + '/slacksendmessagebyuser?',
  };

  /**
   *  Mail
   */
  public static Mail = {
    Google: {
      inbox: API_BASE_URL + '/googlegmaillist/google',
      message: API_BASE_URL + '/googlemessage/google',
      move: API_BASE_URL + '/googlemove/google/',
      compose:
        API_BASE_URL + '/sendmailbyuser/google/me/messages/send?uploadType=multipart',
    },
  };

  public static Payment = {
    session: API_BASE_URL + '/payment/create_session',
  };

  public static JobBoard = {
    prices: API_BASE_URL + '/jobboardprice',
    activeDay: API_BASE_URL + '/jobboardprice/active',
  };

  public static Integrations = {
    all: API_BASE_URL + '/integration',

    orders: API_BASE_URL + '/integration/order',
    order: API_BASE_URL + '/integration/order',
    delete: API_BASE_URL + '/integration/sheildorder',
  };

  public static Settings = {
    Integrations: API_BASE_URL + '/settings/integration',
    OAuth: {
      authorize: API_BASE_URL + '/settings/oauth',
      google: API_BASE_URL + '/settings/google_auth',
      outlook: API_BASE_URL + '/settings/outlook_auth',
      indeed: API_BASE_URL + '/settings/indeed_auth',

      revoke: API_BASE_URL + '/settings/revoke_auth',
    },
  };
}
